import { IconDefinition, IconPrefix, IconName } from '@fortawesome/fontawesome-common-types';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';



const oldAwesomeFilterIcon: IconDefinition = {
	prefix: 'fac' as IconPrefix,
	iconName: 'customOldAwesomeFilter' as IconName,
	icon: [
		25,
		25,
		[],
		'f58d',
		'M23.165,0H1.141A1.177,1.177,0,0,0,.335,2l8.78,9.032V21.094a1.182,1.182,0,0,0,.486.96l3.8,2.733a1.139,1.139,0,0,0,1.793-.96V11.032L23.971,2A1.177,1.177,0,0,0,23.165,0Z'
	]
}


export const OldAwesomeFilter = (props: Omit<FontAwesomeIconProps, 'icon'>) => {

	return (
		<FontAwesomeIcon {...props} icon={oldAwesomeFilterIcon} />
	)
}

